<template>
  <v-dialog v-model="dialog" max-width="750" persistent transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="orange">
          <v-toolbar-title>Dsikualifikasi Data Kepala Sekolah</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text my-5">
        <v-list three-line>
          <v-list-item dense class="px-0">
            <v-list-item-avatar class="my-1" color="info">
              <v-icon dark>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-row>
                <v-col cols="12" lg="6">
                  <div>
                    <span class="info--text mb-0" style="font-size: 17px">
                      {{ $getDeepObj(kandidat, 'ptk_kasek.nama') || '-' }}
                    </span>
                    <div class="mt-1 mb-0">
                      <strong>No UKG:</strong> {{ $getDeepObj(kandidat, 'ptk_kasek.no_ukg') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Jenis PTK:</strong> {{ $getDeepObj(kandidat, 'ptk_kasek.m_jenis_ptk.jenis_ptk') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Tugas Tambahan:</strong>
                      {{ $getDeepObj(kandidat, 'ptk_kasek.ptk_tugases.0.m_tugas.keterangan') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Status Keaktifan:</strong>
                      {{ $getDeepObj(kandidat, 'ptk_kasek.ptk_sekolah.m_keluar.keterangan') || 'Aktif' }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" lg="6">
                  <div>
                    <span class="body-2 grey--text">Informasi Sekolah</span>
                  </div>
                  <div class="mt-1">
                    <span class="mb-0 font-weight-medium" style="font-size: 17px">
                      {{ $getDeepObj(kandidat, 'sekolah.nama') }}
                    </span>
                  </div>
                  <div class="mt-1 mb-0"> <strong>NPSN:</strong> {{ $getDeepObj(kandidat, 'sekolah.npsn') }} </div>
                  <div class="mt-1 mb-0">
                    <strong>Status:</strong>
                    {{ Number($getDeepObj(kandidat, 'sekolah.is_negeri')) === 1 ? 'Negeri' : 'Swasta' }}
                  </div>
                  <div class="mt-1"> <strong>Alamat:</strong> {{ $getDeepObj(kandidat, 'sekolah.alamat') }} </div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div>
          <v-alert text color="orange" dense>
            <v-icon left color="orange">mdi-alert</v-icon>
            <span class="body-2 black--text">
              Silakan lengkapi informasi berikut jika Anda ingin melakukan proses diskualifikasi kandidat
            </span>
          </v-alert>
        </div>
        <v-row>
          <v-col cols="12" lg="6">
            <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
              Pilih alasan diskualifikasi <span class="red--text">*</span>
            </span>
            <v-select
              v-model="form.catatan_verval"
              placeholder="Pilih alasan diskualifikasi"
              :items="['Mengundurkan diri', 'Meninggal dunia', 'Pensiun', 'Alasan lainnya']"
              dense
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="12" lg="6">
            <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
              Unggah dokumen pendukung <span class="red--text">*</span>
            </span>
            <v-file-input
              v-model="form.file"
              :accept="['application/pdf,image/*']"
              outlined
              dense
              hide-details
              prepend-icon=""
              @click:append="onHandleClickAppend"
              :ref="`vFileInput`"
              append-icon="mdi-paperclip"
              placeholder="pilih dokumen (maks 1MB)"
            />
          </v-col>
          <v-col v-if="form.catatan_verval === 'Alasan lainnya'" cols="12">
            <span class="px-0 body-2 grey--text text--darken-1" style="height: 24px">
              Tuliskan alasan diskualifikasi lainnya <span class="red--text">*</span>
            </span>
            <v-textarea
              rows="2"
              outlined
              hide-details
              placeholder="Tuliskan alasan lainnya untuk diskualifikasi kandidat"
              v-model="form.catatan_verval_lain"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small text @click="close">
          Batal
        </v-btn>
        <v-btn class="ma-2" color="orange" dark elevation="0" @click="save">
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupUnggah',
  props: {
    kandidat: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.form = {};
    },

    close() {
      this.dialog = false;
    },

    save() {
      this.$emit('save', Object.assign({}, this.form));
    },

    onHandleClickAppend() {
      this.$refs[`vFileInput`][0].$el.querySelector('input').click();
    },
  },
};
</script>
